import React, { useEffect, useState } from 'react'
import { Input, toAbsoluteUrl } from 'sr/helpers'
import { FormDetails } from 'sr/helpers/ui-components/FormDetails'
import { useParams, useNavigate, useSearchParams, Link } from 'react-router-dom'
import AuthNavComponent from './auth/AuthNav'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { ButtonAuth } from 'sr/helpers/ui-components/ButtonAuth'
import { resetPassword } from 'sr/utils/api/resetPassword'
export const ResetPassword = () => {
  const navigate = useNavigate();
  const [Password, setPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState()
  const [loader, setLoader] = useState(false)
    const intl = useIntl()
    const param = useParams()
    const [session, setSession] = useState('')
    const [searchParams] = useSearchParams();

    useEffect(()=> {
      const session = searchParams.get("session");
      setSession(session)
    },[param])
    const initialValues = {
      password:Password,
      confirmPassword:confirmPassword
    }
    const passwordValidate = Yup.object().shape({
      password:Yup.string().required('INPUT.VALIDATION.PASSWORD').min(8, 'INPUT.VALIDATION.PASSWORD.MIN.CHARACTER').matches(/(?=.*[0-9!@#$%^&*])/, 'INPUT.VALIDATION.PASSWORD.REQUIREMENTS'),
      confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'INPUT.VALIDATION.CONFIRMPASSWORD.MATCH')
  .required('INPUT.VALIDATION.CONFIRMPASSWORD')
  })
      const {errors, handleSubmit} = useFormik({
        initialValues:initialValues,
        enableReinitialize:true,
        validationSchema:passwordValidate,
        onSubmit: async (values)=> {
          try {
            const queryParams = new URLSearchParams()
            queryParams.append('session', session)
            setLoader(true)
            const res = await resetPassword(queryParams, values)
            if(res.success===true) {
                setLoader(false)
                navigate(`/auth`);
            }
            else {
              setLoader(false)
            }
          }
          catch(e:any) {
  setLoader(false)
          }
        }
      })
  return (
    <>
    <AuthNavComponent isLoginPage={true}></AuthNavComponent>
    <main>
   <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
        <div className='lg:flex block'>
        <div className='lg:flex-1 lg:flex flex-col h-fit lg:mx-12 block p-6 bg-white border border-gray-border rounded-xl'>
                   <div className="flex justify-center">
                    <Link to="/" className='z-50'>
                      <img width={150} src={toAbsoluteUrl('/media/logos/logo2.png')} alt=''
                        className='bg-white rounded-lg' />
                    </Link>
      </div>
            <h1 className=' text-xl mt-5'>Reset Password</h1>
            <div className='w-full'>
            <form className='mt-5'>
            <Input
                onChange={(e)=> setPassword(e.target.value)}
                value={Password}
                  label={intl.formatMessage({
                    id: "AUTH.INPUT.PASSWORD",
                    defaultMessage: "Password",
                  })}
                  placeholder={intl.formatMessage({
                    id: "AUTH.INPUT.PASSWORD.PLACEHOLDER",
                    defaultMessage: "Enter your password",
                  })}
                  type={"password"}
                  name="password"
                  error={errors.password}
                ></Input>
                                <Input error={errors.confirmPassword} label={intl.formatMessage({id:"AUTH.INPUT.CONFIRM_PASSWORD", defaultMessage:'Confirm Password'})}
                                    placeholder={intl.formatMessage({id:"AUTH.INPUT.CONFIRM_PASSWORD", defaultMessage:'Confirm Password'})}
                                   onChange={(e)=> setConfirmPassword(e.target.value)}
                                   value={confirmPassword}
                                   type={'password'}>
                                </Input>
                            
                            </form>
                             <div className="mt-5 flex space-x-10 justify-center">
                            <ButtonAuth onClick={handleSubmit}  loader={loader}>Reset Password</ButtonAuth>
        </div></div>
      </div>
    </div></div></main></>
  )
}
